var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveMeasurePerf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TU World - Measure - active"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 316",
    d: "M6.5 26.5V10.8019L15.5 6.06502L24.5 10.8019V26.5H6.5Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line-Copy",
    d: "M8.33789 20.1144L14.0246 14.5301L17.8037 18.2472L22.0627 14.0493",
    stroke: "white",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M23.6582 12.4849L22.722 15.2213L21.9827 14.4703L17.9725 18.4179L17.8045 18.5833L17.6365 18.418L14.0252 14.8659L8.50654 20.2853L8.33564 20.4532L8 20.1114L8.1709 19.9436L13.8576 14.3592L14.0255 14.1943L14.1934 14.3594L17.8044 17.9112L21.6466 14.1289L20.9073 13.3778L23.6582 12.4849Z",
    fill: "#F36F4B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 22.2995L10.9641 20.3833V25.2695H9V22.2995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1621 18.9461L22.1262 16.9341V25.2694H20.1621V18.9461Z",
    fill: "#F36F4B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4844 22.3474L16.5203 20.3354V25.2696H18.4844V22.3474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6307 18.6362L13.766 17.7485L12.784 18.7488V25.2818H14.748L14.6307 18.6362Z",
    fill: "#F36F4B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M28.6061 12.7362L16.2861 5.18546C15.8395 4.93818 15.1605 4.93818 14.7139 5.18546L2.3939 12.7362C2.0795 12.9085 1.93883 13.1706 2.02486 13.4238C2.11089 13.677 2.41057 13.8828 2.81099 13.9637C3.21142 14.0446 3.65177 13.9882 3.96616 13.8159L15.5 6.68992L27.0338 13.8015C27.3482 13.9738 27.7886 14.0302 28.189 13.9493C28.5894 13.8684 28.8891 13.6626 28.9751 13.4094C29.0612 13.1562 28.9205 12.8941 28.6061 12.7218V12.7362Z",
    fill: "#F36F4B"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveMeasurePerf);
export default __webpack_public_path__ + "static/media/ActiveMeasurePerf.dd521e1cb59711ebad75920aa60dc9ab.svg";
export { ForwardRef as ReactComponent };